import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import { VerificationChoice } from '~/components/VerificationModal/types';
import { CLIENT_TYPES_ID, ClientTypes } from '~/constants/clientTypes';

export type TContragentType = (typeof CLIENT_TYPES_ID)[keyof typeof CLIENT_TYPES_ID];

export type TGettingStarted = {
  verification: VerificationChoice | null;
  isUSTaxResident?: boolean | null;
  isForeignFinancialUnderFATCA?: boolean | null;
  isOtherTaxResident?: boolean | null;
  proxyAccountManagers?: boolean | null;
  hasForeignShare?: boolean | null;
  currency: TAutocompleteOption[];
  identificationNumber?: string | null;
  region: TAutocompleteOption | null;
  tariffPackage: TAutocompleteOption | null;
  contragentType: TAutocompleteOption | null;
  tobo: TAutocompleteOption | null;
  applicationId: number | null;
  type?: ClientTypes;
  clientType?: string;
  contragentId?: number | null;
  identificationType: string | null;
  isInTerList: boolean | null;
  isInBankBlackList: boolean | null;
  applicationNumber?: string | null;
};

export type TGettingStartedReIdentification = {
  verification: VerificationChoice;
  isUSTaxResident?: boolean | null;
  isForeignFinancialUnderFATCA?: boolean | null;
  isOtherTaxResident?: boolean | null;
  proxyAccountManagers?: boolean | null;
  hasForeignShare?: boolean | null;
  currency?: TAutocompleteOption[];
  identificationNumber?: string | null;
  region: TAutocompleteOption;
  tariffPackage?: TAutocompleteOption;
  contragentType: TAutocompleteOption | null;
  tobo: TAutocompleteOption;
  applicationId: string;
  type?: ClientTypes;
  clientType?: string;
  contragentId?: number | null;
  identificationType: string | null;
};

export enum InfoStatusContragentCodes {
  JUST_REGISTERED = -1,
  NEW,
  READY_TO_SHIP,
  IN_PROCESSING_BY_THE_BANK,
  UNDER_DEVELOPMENT,
  AGREED,
  REJECTED,
  CLOSED,
}

export type TErrorPayload = {
  data: TGettingStartedThunkError;
};

export type TGettingStartedThunkError = {
  message?: string;
  status?: number;
  errorCode?: string | number;
};

export enum InfoModalButtonTitle {
  LOG_OUT = 'Вийти',
  OPEN_ACCOUNT = 'Відкрити рахунок',
  UPDATE_DATA = 'Оновлення даних',
  SAVE_AND_CONTINUE = 'Зберегти і продовжити',
  CANCEL_AND_CONTINUE = 'Відхилити і продовжити',
}

export enum IdentificationType {
  RE_IDENTIFICATION = 'RE_IDENTIFICATION',
  PRIMARY = 'PRIMARY',
}

export type TB2CheckResult = {
  isContragent: boolean;
  identificationType: string;
};

export type TApplicationStatus = {
  status: number;
};

export interface IContinueProps {
  gettingStarted?: TGettingStarted;
  applicationNumber: string;
  isRedirect?: boolean;
}
